<template>
  <div v-if="ready">
    <div class="row">
      <div class="col-6">
        <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave">
          <div class="card">
            <div class="card-header">
              <h4>Grundriss</h4>
            </div>
            <div class="card-body">
              <div class="img-fit" v-if="wohnung.grundriss">
                <img :src="wohnung.grundriss.data.full_url" />
                <div class="bottom-icon-bar infra-blue">
                  <a href="#" class="infra-blue" @click="openImageModal(wohnung.grundriss.data.full_url)"
                    ><feather class="pointer" type="eye" size="25"></feather
                  ></a>
                  <a class="infra-blue" :href="wohnung.grundriss.data.full_url" target="_blank" download
                    ><feather style="margin-left:5px" class="pointer" type="download" size="25"></feather
                  ></a>
                </div>
              </div>
              <div v-if="!wohnung.grundriss">
                Kein Grundriss hinterlegt.
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="col-6">
        <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave">
          <div class="card half-heigth">
            <div class="card-header">
              <h4>Lageicon</h4>
            </div>
            <div class="card-body">
              <div class="img-fit" v-if="wohnung.lageicon">
                <img :src="wohnung.lageicon.data.full_url" />
                <!--<div class="bottom-icon-bar infra-blue ">
                  <a href="#" class="infra-blue" @click="openImageModal(wohnung.lageicon.data.full_url)"
                    ><feather class="pointer" type="eye" size="25"></feather
                  ></a>
                  <a class="infra-blue" :href="wohnung.lageicon.data.full_url" target="_blank" download
                    ><feather style="margin-left:5px" class="pointer" type="download" size="25"></feather
                  ></a>
                </div>-->
              </div>
              <div v-if="!wohnung.lageicon">
                Kein Lageicon hinterlegt.
              </div>
            </div>
          </div>
        </transition>
                <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave">
          <div class="card">
            <div class="card-header">
              <h4>Projekt Downloads</h4>
            </div>
            <div class="card-body">
              <div v-if="hasDownloads" class="downloads-container">
                <div id="downloads-result-container">
                  <div v-for="download in downloads" :key="'bpdownload-' + download.bp_downloads_id" class="download-result">
                    <div class="download-label infra-blue">{{ download.name }}</div>
                    <div class="download-result-icons">
                      <a :href="download.file.data.full_url" target="_blank"><feather type="download" class="infra-blue pointer"></feather></a>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!hasDownloads">Keine Downloads vorhanden</div>
            </div>
          </div>
        </transition>
      </div>
      <div class="col-6">

      </div>
      <b-modal id="showImageModal" ok-only @ok="closeImageModal()" size="xl" hide-header>
        <div class="img-fit">
          <img :src="imageModalImage" />
        </div>
      </b-modal>
    </div>
    <div class="row">
      <div class="col-12">
        <transition :name="animations.standard.name" :enter-active-class="animations.standard.enter" :leave-active-class="animations.standard.leave">
          <div class="card">
            <div class="card-header">
              <h4>Ihre Dienstleister</h4>
            </div>
            <div class="card-body">
              <div class="table-responsive datatable-vue">
                <b-table
                  show-empty
                  stacked="md"
                  :fields="tbl_dienstleister_fields"
                  :items="display_dienstleister"
                  v-if="display_dienstleister.length"
                >
                  <template v-slot:cell(detail)="row">
                    <feather type="info" class="infra-blue pointer" @click="showDienstleisterDetail(row.item)"></feather>
                  </template>
                  <template slot="empty"><div class="text-center">Keine Dienstleister hinterlegt.</div></template>
                </b-table>
                <b-modal id="showDienstleisterDetail" @ok="closeModal" size="lg" ok-only>
                  <div class="blog-box blog-list row">
                    <div class="col-sm-5" v-if="modal_dienstleister.image">
                      <img class="dl-image" :src="modal_dienstleister.image.full_url" />
                    </div>
                    <div class="col-sm-7">
                      <div class="blog-details">
                        <h4>{{ modal_dienstleister.name }}</h4>
                        <div v-if="modal_dienstleister.extended && modal_dienstleister.extended.branchenString" class="badges-container">
                          <div v-for="(branche, idx) in modal_dienstleister.extended.branchenString.split(',')" :key="'br_pill_' + idx">
                            <span class="badge badge-info">{{ branche }}</span>
                          </div>
                        </div>
                        <p v-if="modal_dienstleister.telefon">Telefon: {{ modal_dienstleister.telefon }}</p>
                        <p v-if="modal_dienstleister.email">Email: {{ modal_dienstleister.email }}</p>
                        <p v-if="modal_dienstleister.extended && modal_dienstleister.extended.branchenString">
                          Fachgebiet: {{ modal_dienstleister.extended.branchenString }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <template slot="modal-header"
                    ><h4>Dienstleister Infos</h4>
                    <hr />
                  </template>
                </b-modal>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "bpAssets",
  data() {
    return {
      ready: false,
      wohnung: false,
      bauprojekt: false,
      hasDownloads: false,
      downloads: [],
      badmappe: false,
      baubeschreibung: false,
      tg_keller_plan: false,
      gesamtlageplan: false,
      display_dienstleister: [],
      modal_dienstleister: false,
      imageModalImage: false,
      tbl_dienstleister_fields: [
        { key: "name", label: "Firma", sortable: true },
        { key: "extended.branchenString", label: "Branchen", sortable: true },
        { key: "detail", label: "Infos", sortable: true },
      ],
    };
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      kuwo: "app/kuwo",
      toasts: "app/toasts",
      dienstleister: "app/dienstleister",
    }),
  },
  async created() {
    await this.getData();
  },
  methods: {
    openImageModal(url) {
      this.imageModalImage = url;
      this.$bvModal.show("showImageModal");
    },
    closeImageModal() {
      this.$bvModal.hide("showImageModal");
      this.imageModalImage = false;
    },
    closeModal() {
      this.$bvModal.hide("showDienstleisterDetail");
      this.modal_dienstleister = false;
    },
    showDienstleisterDetail(dl) {
      this.modal_dienstleister = dl;
      this.$bvModal.show("showDienstleisterDetail");
    },
    async getData() {
      this.wohnung = this.kuwo.find((w) => w.id == this.$route.params.wohnung_id);
      this.bauprojekt = this.wohnung.haus.haus_bp;
      await this.getDownloads();
      await this.getDienstleister();
      this.ready = true;
    },
    async getDownloads() {
      this.downloads = [];
      try {
        const bpDownloads = await this.$directus.getItems("bauprojekt_bp_downloads", {
          filter: {
            bauprojekt_id: this.bauprojekt.id,
          },
          fields: "*.*",
        });
        console.log("bpDownloads for: ");
        console.log(this.bauprojekt.id);
        console.log(bpDownloads);
        bpDownloads.data.forEach(async (dl) => {
          const fileId = dl.bp_downloads_id.file;
          const result = await this.$directus.getItem("directus_files", fileId);
          if (result)
            this.downloads.push({
              name: dl.bp_downloads_id.name,
              file: result.data,
              bp_downloads_id: dl.bp_downloads_id.id,
              relation_id: dl.id,
            });
            this.hasDownloads = true;
        });
        
      } catch (error) {
        console.log(error);
        console.log("Fehler beim Hinzufügen eines Downloads.");
      }
      console.log(this.downloads);
    },
    async getDienstleister() {
      const wohnungId = this.wohnung.id;
      const hausId = this.wohnung.haus.id;
      const bpId = this.wohnung.haus.haus_bp.id;

      let result = {};
      try {
        const filter_wohnung = {
          fields: "dienstleister_id",
          filter: {
            wohnung_id: wohnungId,
          },
        };
        const filter_haus = {
          fields: "dienstleister_id",
          filter: {
            haus_id: hausId,
          },
        };
        const filter_bp = {
          fields: "dienstleister_id",
          filter: {
            bauprojekt_id: bpId,
          },
        };

        const wohnung_dienstleister = await this.$directus.getItems("wohnung_dienstleister", filter_wohnung);
        if (wohnung_dienstleister.data.length) result["wohnung"] = [...wohnung_dienstleister.data];
        const haus_dienstleister = await this.$directus.getItems("haus_dienstleister", filter_haus);
        if (haus_dienstleister.data.length) result["haus"] = [...haus_dienstleister.data];
        const bp_dienstleister = await this.$directus.getItems("bauprojekt_dienstleister", filter_bp);
        if (bp_dienstleister.data.length) result["bauprojekt"] = [...bp_dienstleister.data];
        if (Object.keys(result).length) this.getDienstleisterData(result);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden der Dienstleister", this.toasts.failure);
      }
    },
    async getDienstleisterData(dl) {
      let result = [];
      const keys = Object.keys(dl);
      const len = keys.length;
      for (let i = 0; i < len; i++) {
        const context = keys[i];
        const leng = dl[context].length;
        for (let j = 0; j < leng; j++) {
          const dlId = dl[context][j].dienstleister_id;
          const dienstleister = this.dienstleister.find((f) => f.id == dlId);
          if (dienstleister !== undefined && dienstleister.logo) {
            try {
              const response = await this.$store.dispatch("app/getAsset", dienstleister.logo);
              if (response) dienstleister["image"] = response;
            } catch (error) {
              console.log(error);
              this.$toasted.show("Fehler beim Laden des Dienstleister Logos.", this.toasts.failure);
            }
          }
          if (dienstleister !== undefined && result.find((dls) => dls.id == dlId) == undefined) result.push(dienstleister);
          this.display_dienstleister = result;
        }
      }
    },
  },
};
</script>

<style scoped>
.downloads-container {
  font-size: 1.3em;
}

.downloads-container span {
  vertical-align: text-bottom;
}

.img-fit img {
  width: 100%;
}

.badges-container {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
}

.badges-container div {
  margin-right: 5px;
}
.bottom-icon-bar {
  margin-top: 15px;
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
}

.half-height {
  max-height: 300px;
}

.download-label {
  font-size:1.3em;
}

.downloads-result-container, .download-result {
  display:flex;
  justify-content:space-between;
}

.download-result {
  flex-flow:row;
}

.dl-image {
  width:100%;
}
</style>
